import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './AdminLogin.css';
import logo from '../../images/audithippo.png';

const ADMIN_LOGIN_URL = '/rest/api/v1/admin/login';

function AdminLogin() {
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [code, setCode] = useState('');
    const [error, setError] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!email || !password || !code) {
            setError('Please fill in all fields.');
            return;
        }

        setSubmitting(true);
        try {
            const res = await axios.post(ADMIN_LOGIN_URL, {
                email,
                password,
                authenticator: code,
            }, { headers: { 'Content-Type': 'application/json' } });

            const data = res.data || {};
            console.log('[AdminLogin] response:', res.status, data);
            localStorage.setItem('isAdminLoggedIn', 'true');
            if (data.token)     localStorage.setItem('adminAuthToken', data.token);
            if (data.sessionId) localStorage.setItem('adminSessionId', data.sessionId);
            navigate('/admin/mc-connections');
        } catch (err) {
            const status = err.response?.status;
            const data   = err.response?.data;
            console.error('[AdminLogin] failed:', status, data, err.message);
            const msg = (data && (data.message || data.error))
                || err.message
                || 'Invalid credentials. Please check your email, password and authenticator code.';
            setError(msg);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            {/* Mobile Menu Overlay */}
            <div
                className={`mobile-menu-overlay${menuOpen ? ' show' : ''}`}
                onClick={() => setMenuOpen(false)}
            />

            {/* Mobile Slide Menu */}
            <div className={`mobile-menu${menuOpen ? ' show' : ''}`}>
                <div className="mobile-menu-header">
                    <a href="#" className="logobock d-flex align-items-center gap-2">
                        <div className="hippolog">
                            <img src={logo} alt="AuditHippo" />
                        </div>
                        <span className="brand-name">
                            Audit<span className="hippotxt">Hippo</span>
                        </span>
                    </a>
                    <div
                        className="mobile-menu-close"
                        onClick={() => setMenuOpen(false)}
                        role="button"
                        aria-label="Close menu"
                    >
                        &#10005;
                    </div>
                </div>
                <div className="mobile-menu-items">
                    <div className="mobile-menu-item active">
                        <a className="nav-link" href="#" onClick={(e) => e.preventDefault()}>Login</a>
                    </div>
                </div>
            </div>

            {/* Navbar */}
            <nav className="navbar-custom">
                <div className="container-custom">
                    <div className="d-flex align-items-center justify-content-between w-100 flex-wrap gap-2">
                        <div className="d-flex align-items-center gap-3">
                            <button
                                className="mobile-menu-btn"
                                onClick={() => setMenuOpen(true)}
                                aria-label="Open menu"
                            >
                                <span />
                                <span />
                                <span />
                            </button>
                            <div className="d-flex align-items-center gap-2">
                                <a href="#" className="logobock d-flex align-items-center gap-2">
                                    <div className="hippolog">
                                        <img src={logo} alt="AuditHippo" />
                                    </div>
                                    <span className="brand-name">
                                        Audit<span className="hippotxt">Hippo</span>
                                    </span>
                                </a>
                                <span className="divider-mobile" />
                                <span className="marketing-cloud-text">Admin</span>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>

            {/* Main Content */}
            <main className="adm-page">
                <div className="adm-login-layout">
                    <div className="adm-login-inner">
                        <div className="adm-section-header mb-4">
                            <div>
                                <h2 className="adm-section-title">Admin Login</h2>
                                <p className="adm-section-subtitle">Secure access for administrators</p>
                            </div>
                        </div>

                        <p className="adm-login-screen-label">Admin Login</p>
                        <div className="adm-login-card">
                                <div className="card-body">
                                    <div className="d-flex align-items-center gap-2 mb-4">
                                        <div className="logo-box">AH</div>
                                        <span className="brand-name">AuditHippo</span>
                                    </div>

                                    <span className="adm-login-badge-admin mb-3">Admin Portal</span>

                                    <h3 className="adm-login-title">Admin sign in</h3>
                                    <p className="adm-login-subtitle">Restricted access. Authentication and 2FA required.</p>

                                    <form onSubmit={handleSubmit} noValidate>
                                        <div className="mb-3">
                                            <label htmlFor="adminEmail" className="adm-login-label">Admin email</label>
                                            <input
                                                type="email"
                                                className="adm-login-input"
                                                id="adminEmail"
                                                placeholder="admin@company.com"
                                                value={email}
                                                onChange={(e) => { setEmail(e.target.value); setError(''); }}
                                                autoComplete="email"
                                                disabled={submitting}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="adminPassword" className="adm-login-label">Password</label>
                                            <input
                                                type="password"
                                                className="adm-login-input"
                                                id="adminPassword"
                                                placeholder="********"
                                                value={password}
                                                onChange={(e) => { setPassword(e.target.value); setError(''); }}
                                                autoComplete="current-password"
                                                disabled={submitting}
                                            />
                                        </div>
                                        <div className="mb-2">
                                            <label htmlFor="adminCode" className="adm-login-label">Authenticator code</label>
                                            <input
                                                type="text"
                                                className="adm-login-input"
                                                id="adminCode"
                                                placeholder="6-digit code"
                                                value={code}
                                                onChange={(e) => { setCode(e.target.value); setError(''); }}
                                                autoComplete="one-time-code"
                                                disabled={submitting}
                                            />
                                        </div>
                                        {error && (
                                            <p className="adm-login-error">{error}</p>
                                        )}

                                        <button type="submit" className="adm-login-btn-admin w-100 mb-3" disabled={submitting}>
                                            {submitting ? 'Signing in...' : 'Sign in to Admin Portal'}
                                        </button>

                                    </form>

                                    <p className="adm-login-footer mb-0">
                                        Lost admin access?{' '}
                                        <a href="https://www.bluehippo.io/contact.html" target="_blank" rel="noopener noreferrer" className="adm-login-link adm-login-link-admin">Contact support</a>
                                    </p>
                                </div>
                        </div>
                    </div>
                </div>
            </main>

        </>
    );
}

export default AdminLogin;
